module.exports = __webpack_public_path__ + "static/img/wq-6.8e6dccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/wq-6.png
// module id = nfH6
// module chunks = 0